module.exports = __webpack_public_path__ + "static/media/KidsCut.21b5e6bc.jpg";